
import { closeCaptionmeetingState } from '../../models/callModel';
import { Types }from '../action/action';

const initialState = {
  transcripts:[],
  updatedLanguages: {
    transcription_str: 'Global English',
    transcription_code: 'en'
  },
  keywords:['Task', 'Note', 'Important', 'Name', 'Mark', 'List', 'Event','encyclopaedia'],
  highlights:[],
  tasklist:[],
  files: [],
  editautomatedmins: [],
  quilDiv: '',
  shareFrom: '',
  downloadURL:'',
  asrCallingFrom: 'callList',
  localStreaming:'stopped',
  remoteStreaming: 'stopped',
  guid: '',
  voiceTranscript: [],
  voiceDataStore: {
    voiceCaption: [],
    voiceCaptionText: '',
    voiceTimer:''
  },
  isTranscriptLoading: false,
  transAPI:[],
  audioTranscript:[],
  transcriptLoading:true,
  transcriptEnable:false,
  autoDwld:false,
  voicemailTrans: ""
  
};

export const closeCaption = (state: closeCaptionmeetingState = initialState, action: any) => {
  switch (action.type) {
  case Types.TRANSCRIPTS_LIST:
    return {
      ...state, transcripts: action.payload.transcripts
    };
  case Types.TRANSCRIPTS_ADD_KEYWORD:
    return {
      ...state, keywords: action.payload.keywords
    };
  case Types.TRANSCRIPTS_HIGHLIGHTS:
    return {
      ...state, highlights: action.payload.highlights
    };
  case Types.TRANSCRIPTS_NEWTASK:
    return {
      ...state, tasklist: action.payload.tasklist
    };
  case Types.TRANSCRIPT_FILE_UPLOAD:
    return {
      ...state, files: action.payload.files
    };
  case Types.AUTOMATED_MINS_LIST_EDIT:
    return {
      ...state, editautomatedmins: action.payload.editautomatedmins,isTranscriptLoading:action.payload.isTranscriptLoading
    };
  case Types.SHARE_TEXT:
    return {
      ...state, shareFrom: action.payload.shareFrom
    };
  case Types.ASR_CALLING_FROM:
    return {
      ...state, asrCallingFrom:action.payload.asrCallingFrom , isTranscriptLoading:action.payload.isTranscriptLoading
    };
  case Types.ASR_CLEAR_DATA:
    return {
      ...state, editautomatedmins:[],transcripts:[],highlights:[],files:[],quilDiv:'',
      shareFrom: '', asrCallingFrom:'callList',localStreaming:'stopped',remoteStreaming:'stopped'
    };
  case Types.ASR_STATUS:
    return {
      ...state, localStreaming: action.payload.localStreaming, remoteStreaming: action.payload.remoteStreaming,
      guid: action.payload.guid
    };
  case Types.ASR_LANG_UPDATE:
    return {
      ...state, updatedLanguages:action.payload
    };
  case Types.VOICE_MAIL_TRANSCRIPTS:
    return {
      ...state, voiceTranscript: action.payload.transcripts,isTranscriptLoading:false
    };
  case Types.VOICE_MAIL_CAPTION:
    return {
      ...state, voiceDataStore: action.payload.voiceDataStore
    };

    case Types.DIV_EDITOR:
      return {
        ...state, quilDiv:action.payload.quilDiv
      }
      case Types.TRANS_RESULT:
        return {
          ...state, transAPI:action.payload.transAPI
        }
        case Types.AUDIO_CC:
          return {
            ...state, audioTranscript:action.payload.audioTranscript,transcriptLoading:action.payload.transcriptLoading,transcriptEnable:action.payload.transcriptEnable,autoDwld:action.payload.autoDwld
          }

        case Types.VOICE_MAIL_LIST: 
          return {
            ...state,
            voicemailTrans: action.payload.voicemailTrans
          }; 
  
  default:
    return state;
  };
};
    